module.exports = __webpack_public_path__ + "static/media/icon_view.44210e3b.svg";